module.exports = __webpack_public_path__ + "img/motrin_ib_coated_caplets.e13af126.png";